// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arcanine: PokeData = {
  "id": 59,
  "name": "arcanine",
  "height": 19,
  "weight": 1550,
  "base_experience": 194,
  "types": [
    PokeType.FIRE
  ],
  "api_moves": [
    "take-down",
    "double-edge",
    "leer",
    "bite",
    "roar",
    "ember",
    "flamethrower",
    "agility",
    "flame-wheel",
    "reversal",
    "crunch",
    "extreme-speed",
    "helping-hand",
    "odor-sleuth",
    "howl",
    "flare-blitz",
    "thunder-fang",
    "fire-fang",
    "retaliate",
    "play-rough",
    "burn-up"
  ],
  "moves": [
    "leer",
    "bite",
    "ember",
    "flamethrower",
    "crunch",
    "flare-blitz",
    "thunder-fang",
    "fire-fang",
    "play-rough",
    "eruption",
    "fire-spin",
    "magma-storm",
    "fire-ball"
  ],
  "evolution_chain": {
    "id": 25,
    "item": null,
    "species": [
      {
        "name": "growlithe",
        "order": 63,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arcanine",
        "order": 64,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": 58,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "fire-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 117,
    "speed": 131,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
